// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Stack, Text } from '@mantine/core';
import Moment from 'react-moment';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgencyTemplateDTO } from '../../../../Types/MessageT';
import TemplateActions from './AgencyItemActions';

interface Props {
  template: AgencyTemplateDTO;
  onUpdate: (patch: Partial<AgencyTemplateDTO>) => void;
  onDelete: () => void;
}

const TemplateListItem: FC<Props> = ({ template, onUpdate, onDelete }) => {
  const { id, name, lastModified } = template;
  const navigate = useNavigate();

  return (
    <Group position="apart">
      <Stack spacing={0}>
        <Text
          size="md"
          sx={{ cursor: 'pointer', color: 'black' }}
          variant="link"
          onClick={() => navigate(`/settings/agency/message/${id}`)}
        >
          {name}
        </Text>
        <Text size="xs" color="dimmed">
          Bearbeitet{'  '}
          <Moment fromNow date={lastModified} />
        </Text>
      </Stack>
      <div>
        <TemplateActions template={template} onUpdate={onUpdate} onDelete={onDelete} />
      </div>
    </Group>
  );
};

export default TemplateListItem;
